import axios from "axios"

export function getErrorMessage(error: unknown): string {
    if (!error) {
        return 'Erro não identificado'
    }
    if (axios.isAxiosError(error) && error.response?.data?.message) {
        return error.response.data.message
    }
    if (typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
        return error.message
    }
    return String(error)
}
